var RatingComponent = /** @class */ (function () {
    function RatingComponent() {
        this._rating = 0;
        this.stars = [];
        this.showNumber = true;
    }
    Object.defineProperty(RatingComponent.prototype, "rating", {
        set: function (r) {
            this._rating = r;
            if (r < 0.25) {
                this.stars = ['ca-star-o'];
                return;
            }
            var s = [];
            for (var i = 0; i < Math.floor(r); i++) {
                s.push('ca-star');
            }
            if (Math.round(r) > r) {
                s.push('ca-star-half');
            }
            this.stars = s;
        },
        enumerable: true,
        configurable: true
    });
    return RatingComponent;
}());
export { RatingComponent };
